let year = new Date().getFullYear();
export const copyright = {
  english: {
    
    title: 'Copyright',
    sggsProject: 'Copyright',
    subTagLine: 'Lorem Ipsum is simply dummy text of the printing',
    theVision: 'Lorem Ipsum is simply dummy text of the printing',

    Paragraph1:
      'All content published on this website, including but not limited to literal translation, interpretive transcreation, commentaries, and other scholarly materials, is protected by US copyright laws and is the intellectual property of The Guru Granth Sahib Project. The content provided on this website is intended for educational and informational purposes only.',
    
    Paragraph2:
      'Visitors to this website are granted a non-exclusive, non-transferable license to access and use the content for personal, non-commercial purposes. This license allows users to view, read, and print the content, provided that it is used in accordance with fair use principles and applicable copyright laws.',
    
    Paragraph3:
      'Unauthorized copying, reproduction, distribution, modification, or any other use of the content, in whole or in part, without the explicit written permission of The Guru Granth Sahib Project is strictly prohibited. This includes uploading, posting, or transmitting the content to other websites, platforms, or electronic media without proper authorization.',
    
    Paragraph4:
      'Any use of the content on this website should properly acknowledge, cite, and be attributed to the original author(s) and source of the material. Citation guidelines should be followed in accordance with academic standards and the specific instructions provided below:',
    
    Paragraph5:
      'Chicago format: “Title of Web Page.” The Guru Granth Sahib Project. Sikh Research Institute, publication month day, year. URL.',
    
    Paragraph6_1:
      'Sample: “Bani Asa Ki Var in the English Language.” The Guru Granth Sahib. Sikh Research Institute, September 1, 2020. ',
    Link6:
      'https://gurugranthsahib.io/bani/AKV',
    
    Paragraph7:
      'MLA format: “Title of Web Page.” The Guru Granth Sahib Project, Day Month. Year of Publication, URL, Accessed Date of Access[.]',
    
    Paragraph8_1:
      'Sample: “Bani Asa Ki Var in the English Language.” The Guru Granth Sahib Project, 1 Sept. 2020, ',
    Link8:
      'https://gurugranthsahib.io/bani/AKV',
    Paragraph8_2:
      //'. Accessed 7 July 2023.',
      `.Accessed 7 July ${year}.`,
    
    Paragraph9:
      'APA format: Publishing Organization. (Year, Month, Day of Publication). Title of Webpage. Website Name. Retrieved Month Day, Year, from URL.',
    
    Paragraph10_1:
      //'Sample:  Sikh Research Institute (2020, December 1). Bani Asa Ki Var in the English Language. The Guru Granth Sahib Project. Retrieved October 7, 2023, from',
      `Sample:  Sikh Research Institute (2020, December 1). Bani Asa Ki Var in the English Language. The Guru Granth Sahib Project. Retrieved October 7, ${year}, from`,
    Link10:
      'https://gurugranthsahib.io/bani/AKV',
    
    Paragraph11:
      'While The Guru Granth Sahib Project strives to provide accurate and reliable information, the website and its content are provided on an "as is" basis without any warranties, express or implied. The Guru Granth Sahib Project assumes no legal responsibility for any damages resulting from errors, omissions, or inaccuracies in the content resulting from the use or reliance on the content provided on this website.',
    
    Paragraph12:
      'However, The Guru Granth Sahib Project recognizes its responsibility to correct errors promptly. The team also acknowledges that theirs is a work in progress.',
    
    Paragraph13_1:
      'Please contact us via email at ',
    Email13:
      'corrections@sikhri.org',
    Paragraph13_2:
      ' to request a correction if you have identified any error, minor or significant.',

    Paragraph14:
      'By accessing and using this website, you agree to comply with all applicable copyright laws and the terms and conditions outlined in this copyright notice. The Guru Granth Sahib Project reserves the right to modify or update this notice at any time without prior notice.',

    Paragraph15_1:
      'For inquiries regarding the use of content from this website or to request permission for any specific use, please contact The Guru Granth Sahib Project at ',
    Email15:
      'community@sikhri.org',

    Paragraph16:
      'This copyright notice is effective as of the date of publication and supersedes any previous notices or statements regarding copyright on this website.',


    Paragraph17:
      'The Guru Granth Sahib Project',
    Link18:
      'https://gurugranthsahib.io',
    Paragraph19:
     // 'Updated 2023',
       `Updated ${year}`,


    Paragraph20:
      //'© The Guru Granth Sahib Project 2023. All Rights Reserved.',
      `© The Guru Granth Sahib Project ${year}. All Rights Reserved.`,

  },




  panjabi: {

    title: 'Copyright',
    sggsProject: 'Copyright',
    subTagLine: 'Lorem Ipsum is simply dummy text of the printing',
    theVision: 'Lorem Ipsum is simply dummy text of the printing',

    Paragraph1:
      'All content published on this website, including but not limited to literal translation, interpretive transcreation, commentaries, and other scholarly materials, is protected by US copyright laws and is the intellectual property of The Guru Granth Sahib Project. The content provided on this website is intended for educational and informational purposes only.',
    
    Paragraph2:
      'Visitors to this website are granted a non-exclusive, non-transferable license to access and use the content for personal, non-commercial purposes. This license allows users to view, read, and print the content, provided that it is used in accordance with fair use principles and applicable copyright laws.',
    
    Paragraph3:
      'Unauthorized copying, reproduction, distribution, modification, or any other use of the content, in whole or in part, without the explicit written permission of The Guru Granth Sahib Project is strictly prohibited. This includes uploading, posting, or transmitting the content to other websites, platforms, or electronic media without proper authorization.',
    
    Paragraph4:
      'Any use of the content on this website should properly acknowledge, cite, and be attributed to the original author(s) and source of the material. Citation guidelines should be followed in accordance with academic standards and the specific instructions provided below:',
    
    Paragraph5:
      'Chicago format: “Title of Web Page.” The Guru Granth Sahib Project. Sikh Research Institute, publication month day, year. URL.',
    
    Paragraph6_1:
      'Sample: “Bani Asa Ki Var in the English Language.” The Guru Granth Sahib. Sikh Research Institute, September 1, 2020. ',
    Link6:
      'https://gurugranthsahib.io/bani/AKV',
    
    Paragraph7:
      'MLA format: “Title of Web Page.” The Guru Granth Sahib Project, Day Month. Year of Publication, URL, Accessed Date of Access[.]',
    
    Paragraph8_1:
      'Sample: “Bani Asa Ki Var in the English Language.” The Guru Granth Sahib Project, 1 Sept. 2020, ',
    Link8:
      'https://gurugranthsahib.io/bani/AKV',
    Paragraph8_2:
      //'. Accessed 7 July 2023.',
      `. Accessed 7 July ${year}.`,
    
    Paragraph9:
      'APA format: Publishing Organization. (Year, Month, Day of Publication). Title of Webpage. Website Name. Retrieved Month Day, Year, from URL.',
    
    Paragraph10_1:
      //'Sample:  Sikh Research Institute (2020, December 1). Bani Asa Ki Var in the English Language. The Guru Granth Sahib Project. Retrieved October 7, 2023, from',
      `Sample:  Sikh Research Institute (2020, December 1). Bani Asa Ki Var in the English Language. The Guru Granth Sahib Project. Retrieved October 7, ${year}, from`,
    Link10:
      'https://gurugranthsahib.io/bani/AKV',
    
    Paragraph11:
      'While The Guru Granth Sahib Project strives to provide accurate and reliable information, the website and its content are provided on an "as is" basis without any warranties, express or implied. The Guru Granth Sahib Project assumes no legal responsibility for any damages resulting from errors, omissions, or inaccuracies in the content resulting from the use or reliance on the content provided on this website.',
    
    Paragraph12:
      'However, The Guru Granth Sahib Project recognizes its responsibility to correct errors promptly. The team also acknowledges that theirs is a work in progress.',
    
    Paragraph13_1:
      'Please contact us via email at ',
    Email13:
      'corrections@sikhri.org',
    Paragraph13_2:
      ' to request a correction if you have identified any error, minor or significant.',

    Paragraph14:
      'By accessing and using this website, you agree to comply with all applicable copyright laws and the terms and conditions outlined in this copyright notice. The Guru Granth Sahib Project reserves the right to modify or update this notice at any time without prior notice.',

    Paragraph15_1:
      'For inquiries regarding the use of content from this website or to request permission for any specific use, please contact The Guru Granth Sahib Project at ',
    Email15:
      'community@sikhri.org',

    Paragraph16:
      'This copyright notice is effective as of the date of publication and supersedes any previous notices or statements regarding copyright on this website.',


    Paragraph17:
      'The Guru Granth Sahib Project',
    Link18:
      'https://gurugranthsahib.io',
    Paragraph19:
      //'Updated 2023',
      `Updated ${year}`,


    Paragraph20:
      //'© The Guru Granth Sahib Project 2023. All Rights Reserved.',
      `© The Guru Granth Sahib Project ${year}. All Rights Reserved.`,

  },
};
